import useBreakpoint from 'use-breakpoint'

import { ScreenSize } from '@/app/constants'

import { breakpoints } from '../core/tailwind-config'

export const useCurrentBreakpoint = () =>
  useBreakpoint(breakpoints, ScreenSize.Xxs)
